import React from 'react'
import './banne.css'
import Image from './image.jpg'
import { getName } from './../../features/userSlice';
import { useSelector } from 'react-redux';
import { Button } from '@material-ui/core';
function Banner({ setLoginShow, loginShow }) {
  const name = useSelector(getName);
  return (
    <div className="banner">
      <div className="banner-about flex-column">
        <h1 className="text-center"> TestBook</h1>
        <br />
        <br />
        <p>
          The ultimate resource to prepare for Competitive Exams. All previous
          year questions sorted chapter wise on one platform.
        </p>
        <br />
        {/* <br/> */}
        {name === "" && (
          <Button 
          className="align-center" 
          variant="outlined" 
          color="primary" 
          onClick = {() => setLoginShow(!loginShow)}>
            Get Started
          </Button>
        )}
      </div>
      <div className="img">
        <img src={Image} alt="test screen" />
      </div>
    </div>
  );
}

export default Banner
